import ReactGA from "react-ga4";
import { useEffect, lazy, Suspense } from "react";
import './App.css';
import * as React from "react";
import { HelmetProvider } from "react-helmet-async";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import Accueil from './pages/accueil';

const APropos = lazy(() => import('./pages/apropos'));
const Service = lazy(() => import('./pages/service'));
const Partenaire = lazy(() => import('./pages/partenaires'));
const CCM = lazy(() => import('./pages/ccm'));
const Bookmaker = lazy(() => import('./pages/bookmaker'));
const Guide = lazy(() => import('./pages/guide'));
const Contact = lazy(() => import('./pages/contact'));
const Inscription = lazy(() => import('./pages/inscription'));
const Connexion = lazy(() => import('./pages/connexion'));
const ForgotPassword = lazy(() => import('./pages/forgotPassword'));
const ResetPassword = lazy(() => import('./pages/resetPassword'));
const Dashboard = lazy(() => import('./pages/dashboard'));
const ListOperationsSection = lazy(() => import('./pages/composants/DashboardSection/ListOperationsSection'));
const PaiementSection = lazy(() => import('./pages/composants/DashboardSection/paiementSection'));
const ReglageSection = lazy(() => import('./pages/composants/DashboardSection/reglageSection'));
const InfoSection = lazy(() => import('./pages/composants/DashboardSection/infoSection'));
const PartenaireAttente = lazy(() => import('./pages/composants/DashboardSection/PartenaireAttente'));
const AddJoueurSection = lazy(() => import('./pages/composants/DashboardSection/addJoueurSection'));
const MonCompteSection = lazy(() => import('./pages/composants/DashboardSection/monCompteSection'));

const PageFallback = (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: '60vh',
  }} />
);

const lazyRoute = (Component) => (
  <Suspense fallback={PageFallback}>
    <Component />
  </Suspense>
);

const router = createBrowserRouter([
  {
    path: "/",
    element: <Accueil />,
  },
  {
    path: "/a-propos",
    element: lazyRoute(APropos),
  },
  {
    path: "/service",
    element: lazyRoute(Service),
  },
  {
    path: "/partenaire",
    element: lazyRoute(Partenaire),
  },
  {
    path: "/ccm",
    element: lazyRoute(CCM),
  },
  {
    path: "/bookmaker",
    element: lazyRoute(Bookmaker),
  },
  {
    path: "/guide",
    element: lazyRoute(Guide),
  },
  {
    path: "/contact",
    element: lazyRoute(Contact),
  },
  {
    path: "/inscription",
    element: lazyRoute(Inscription),
  },
  {
    path: "/connexion",
    element: lazyRoute(Connexion),
  },
  {
    path: "/forgotPassword",
    element: lazyRoute(ForgotPassword),
  },
  {
    path: "/reset-password",
    element: lazyRoute(ResetPassword),
  },
  {
    path: "/dashboard/:id_user/:type_user",
    element: lazyRoute(Dashboard),
  },
  {
    path: "/dashboard/:id_user/:type_user/operations",
    element: lazyRoute(ListOperationsSection),
  },
  {
    path: "/dashboard/:id_user/:type_user/paiements",
    element: lazyRoute(PaiementSection),
  },
  {
    path: "/dashboard/:id_user/:type_user/reglage",
    element: lazyRoute(ReglageSection),
  },
  {
    path: "/dashboard/:id_user/:type_user/info",
    element: lazyRoute(InfoSection),
  },
  {
    path: "/dashboard/:id_user/:type_user/addJoueur",
    element: lazyRoute(AddJoueurSection),
  },
  {
    path: "/dashboard/:id_user/:type_user/monCompte",
    element: lazyRoute(MonCompteSection),
  },
  {
    path: "/dashboard/:id_user/:type_user/partenaire",
    element: lazyRoute(PartenaireAttente),
  },
]);

function App() {

  useEffect(() => {
    ReactGA.initialize("G-GEM8CRVVL4");

    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname
    });

    let lastPath = window.location.pathname;
    const unsubscribe = router.subscribe((state) => {
      const path = state.location.pathname;
      if (path !== lastPath) {
        lastPath = path;
        ReactGA.send({ hitType: "pageview", page: path });
      }
    });

    return unsubscribe;
  }, []);
  return (
    <HelmetProvider>
      <RouterProvider router={router} />
    </HelmetProvider>
  );
}

export default App;
